import gql from 'graphql-tag';

export const FRAGMENT_BRAND_BRIEF = gql`
  fragment BrandBrief on BrandBrief {
    id
    name
    title
    briefType
    body
    lastModifyingUser {
      name
    }
    updatedAt
    brandVoice {
      id
      name
    }
  }
`;
